export const wasMemberIngested = (patient: fhir.Patient | null) => {
  const ingestedPatient = patient?.meta?.tag?.find(tag => {
    const isKnownPatient =
      tag.code === 'SMART on FHIR Patient' || tag.code === 'Elation Patient';
    const isKnownSource =
      tag.system === 'http://lifeomic.com/fhir/source' ||
      tag.system === 'http://lifeomic.com/fhir/source-type';
    return isKnownPatient && isKnownSource;
  });

  return Boolean(ingestedPatient);
};
